"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Parsowanie tekstowego formatu daty do Date
 * @param date data w formacie YYYY-MM-DD lub YYYY-MM-DD HH:mm:ss
 */
function dateParse(date) {
    if (date.length === 10) {
        return new Date((+date[0]) * 1000 + (+date[1]) * 100 + (+date[2]) * 10 + (+date[3]), (+date[5]) * 10 + (+date[6]) - 1, (+date[8]) * 10 + (+date[9]));
    }
    else {
        return new Date((+date[0]) * 1000 + (+date[1]) * 100 + (+date[2]) * 10 + (+date[3]), (+date[5]) * 10 + (+date[6]) - 1, (+date[8]) * 10 + (+date[9]), (+date[11]) * 10 + (+date[12]), (+date[14]) * 10 + (+date[15]), (+date[17]) * 10 + (+date[18]));
    }
}
exports.default = dateParse;
/*
export default function dateParse(date: string): Date {
  if (date.length === 10) {
    return new Date(date + 'T00:00:00');
  } else {
    if (date[10] === 'T') {
      return new Date(date);
    } else {
      return new Date(date.substr(0, 10) + 'T' + date.substr(11));
    }

  }
}
*/
//# sourceMappingURL=dateParse.js.map